import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    newPassWrap: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        marginBottom: "1.5rem",
    },

    passDots: {
        display: "flex",
        flexDirection: "row",
        position: "relative",
        float: "left",
        alignItems: "center",
    },

    passText: {
        display: "flex",
        flexDirection: "row",
        position: "relative",
        left: "34px",
    },

    dot1Red: {
        backgroundColor: "#8F0000",
        height: "6px",
        width: "6px",
        borderRadius: "50%",
        position: "absolute",
        left: "0",
    },
    dot2Grey: {
        backgroundColor: "#E2DDDD",
        height: "6px",
        width: "6px",
        borderRadius: "50%",
        position: "absolute",
        left: "10px",
    },

    dot3Grey: {
        backgroundColor: "#E2DDDD",
        height: "6px",
        width: "6px",
        borderRadius: "50%",
        position: "absolute",
        left: "20px",
    },

    dot1Orange: {
        backgroundColor: "#FF9C3D",
        height: "6px",
        width: "6px",
        borderRadius: "50%",
        position: "absolute",
        left: "0",
    },
    dot2Orange: {
        backgroundColor: "#FF9C3D",
        height: "6px",
        width: "6px",
        borderRadius: "50%",
        position: "absolute",
        left: "10px",
    },

    dot1Green: {
        backgroundColor: "#008C47",
        height: "6px",
        width: "6px",
        borderRadius: "50%",
        position: "absolute",
        left: "0",
    },
    dot2Green: {
        backgroundColor: "#008C47",
        height: "6px",
        width: "6px",
        borderRadius: "50%",
        position: "absolute",
        left: "10px",
    },

    dot3Green: {
        backgroundColor: "#008C47",
        height: "6px",
        width: "6px",
        borderRadius: "50%",
        position: "absolute",
        left: "20px",
    },
    indicatorStyle: {
        fontSize: "1.2rem",
        display: "flex",
        flexDirection: "row",
    },

    indicatorWrapper: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        marginRight: "36px",
        paddingBottom: "4px",
    },

    float: {
        float: "left",
        paddingBottom: "4px",
    },
}));
